/*** * 新闻详情 * */
<template>
	<div id="newsDetail" style="min-height:600px;width: 60%;margin: 0 auto;box-sizing: border-box;padding: 20px;">
		<h2 class="newsTitle" v-text="newsDataObj.title" style="border-bottom: 1px solid #e7e7eb;margin: 0;padding-bottom: 20px;"></h2>
		<p style="font-size: 20px;">
			<span class="author" v-text="newsDataObj.author" style="color: #576b95;margin-right: 20px;"></span>
			<span class="updatedAt" v-text="computeTime(newsDataObj.updatedAt)" style="color: rgba(0,0,0,0.3);"></span>
		</p>
		<article class="newsContent" v-html="newsDataObj.text">

		</article>
		<article style="text-align: center;color: #717375;font-size: 14px;position: fixed;top: 200px;right: 150px;box-sizing: border-box;padding: 20px;border: 1px solid #d9dadc;background-color: white;">
			<img src="../images/icon/qrcode.png" /><br />
			<span>微信扫一扫</span><br />
			<span>关注该公众号</span>
		</article>
	</div>
</template>

<script>
	export default {
		name: 'newsDetail',
		data() {
			return {
				data: 'asfas',
				newsDataObj: {},
			}
		},
		//监听
		watch: {},

		//页面完成以后
		mounted: function() {
			console.log(44, this.$route.query.id)
			this.requestNewsDetail(this.$route.query.id);
		},
		//事件处理
		methods: {
			// 时间戳计算
			computeTime: function(d) {
				return this.appfn.creatTime(d);
			},
			//-------------------------------------------------------------------------------------------------------------------------------------------------------
			// 请求新闻详情
			requestNewsDetail: function(id) {
				this.request.get({
					url: '/edg/post/' + id,
					callback: function(d) {
						this.newsDataObj = d.data;
						console.log('请求新闻详情：', this.newsDataObj);
					}.bind(this)
				})
			},
		},

	}
</script>

<style>
	#newsDetail .newsContent img {
		max-width: 100% !important;
	}
</style>

<style scoped>
#newsDetail{
	min-width: 1080px;
	overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/newsDetail.vue